import React, { useState } from 'react';
import './NewCategoria.css'; // Importamos los estilos específicos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faPlus, 
    faTimes, 
    faCheck, 
    faTag, 
    faFolder, 
    faSitemap, 
    faTrash 
} from '@fortawesome/free-solid-svg-icons';
import baseURL from '../../url';

// Sistema de notificaciones usando las clases GLOBALES del CSS
const Toast = ({ toasts }) => {
  if (toasts.length === 0) return null;

  return (
    <div className="product-toast-container">
      {toasts.map(toast => (
        <div key={toast.id} className={`product-toast ${toast.type}`}>
          <div className="toast-icon">
            {toast.type === 'success' && '✅'}
            {toast.type === 'error' && '❌'}
            {toast.type === 'warning' && '⚠️'}
            {toast.type === 'info' && 'ℹ️'}
          </div>
          <div className="toast-content">
            <div className="toast-title">{toast.message}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default function NewCategoria() {
    const [mensaje, setMensaje] = useState('');
    const [categoria, setCategoria] = useState('');
    const [subcategorias, setSubcategorias] = useState([]);
    const [nuevaSubcategoria, setNuevaSubcategoria] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [toasts, setToasts] = useState([]);

    // Sistema de notificaciones
    const showToast = (message, type = 'info') => {
        const id = Date.now();
        const newToast = { id, message, type };
        setToasts(prev => [...prev, newToast]);
        
        setTimeout(() => {
            setToasts(prev => prev.filter(toast => toast.id !== id));
        }, 4000);
    };

    const toggleModal = () => {
        setCategoria('');
        setSubcategorias([]);
        setNuevaSubcategoria('');
        setMensaje('');
        setModalOpen(!modalOpen);
    };

    // Manejar subcategorías
    const agregarSubcategoria = () => {
        if (!nuevaSubcategoria.trim()) {
            showToast('Ingrese el nombre de la subcategoría', 'warning');
            return;
        }
        
        if (nuevaSubcategoria.length < 2) {
            showToast('La subcategoría debe tener al menos 2 caracteres', 'error');
            return;
        }

        if (subcategorias.some(sub => sub.toLowerCase() === nuevaSubcategoria.trim().toLowerCase())) {
            showToast('Esta subcategoría ya existe', 'warning');
            return;
        }

        setSubcategorias(prev => [...prev, nuevaSubcategoria.trim()]);
        setNuevaSubcategoria('');
    };

    const eliminarSubcategoria = (index) => {
        setSubcategorias(prev => prev.filter((_, i) => i !== index));
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            agregarSubcategoria();
        }
    };

    const validarFormulario = () => {
        if (!categoria.trim()) {
            showToast('Ingrese el nombre de la categoría', 'error');
            return false;
        }
        if (categoria.length < 2) {
            showToast('La categoría debe tener al menos 2 caracteres', 'error');
            return false;
        }
        if (categoria.length > 50) {
            showToast('La categoría no puede exceder 50 caracteres', 'warning');
            return false;
        }
        return true;
    };

    const crear = async () => {
        if (!validarFormulario()) return;

        const data = {
            categoria: categoria.trim(),
            subcategorias: subcategorias
        };

        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/categoriasPost.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            });

            const result = await response.json();

            if (result.mensaje) {
                setMensaje('');
                showToast(result.mensaje, 'success');
                toggleModal();
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            } else if (result.error) {
                setMensaje('');
                showToast(result.error, 'error');
            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            showToast('Error de conexión. Inténtelo nuevamente.', 'error');
        }
    };

    // Función para obtener clase del contador de caracteres
    const getCharacterCounterClass = (current, max) => {
        if (current >= max * 0.9) return 'character-counter error';
        if (current >= max * 0.7) return 'character-counter warning';
        return 'character-counter';
    };

    return (
        <div className='NewContain'>
            <Toast toasts={toasts} />
            
            {/* Botón principal usando clases del sistema global */}
            <button 
                onClick={toggleModal} 
                className='btn-product-primary flex-center'
                style={{ gap: '8px' }}
            >
                <FontAwesomeIcon icon={faPlus} size="sm" />
                Nueva Categoría
            </button>

            {modalOpen && (
                <div className='product-modal-backdrop'>
                    <div className='product-modal-container' style={{ maxWidth: '700px' }}>
                        {/* Header usando clases globales */}
                        <div className='product-modal-header'>
                            <div className='product-modal-title'>
                                <FontAwesomeIcon icon={faFolder} size="lg" />
                                Crear Nueva Categoría
                            </div>
                            <button className='product-close-button' onClick={toggleModal}>
                                <FontAwesomeIcon icon={faTimes} size="lg" />
                            </button>
                        </div>

                        {/* Body usando clases globales */}
                        <div className='product-modal-body'>
                            {/* Sección de Categoría Principal */}
                            <div className="product-section-card mb-24">
                                <div className="product-section-header">
                                    <div className="product-section-title">
                                        <FontAwesomeIcon icon={faFolder} />
                                        Categoría Principal
                                    </div>
                                </div>

                                <div className="product-section-content">
                                    <div className='product-form-group'>
                                        <label className='product-form-label'>
                                            <FontAwesomeIcon icon={faTag} size="sm" />
                                            Nombre de la Categoría *
                                        </label>
                                        <input
                                            type='text'
                                            className={`product-form-input ${categoria.length > 40 ? 'input-error' : categoria.length > 10 ? 'input-success' : ''}`}
                                            value={categoria}
                                            onChange={(e) => setCategoria(e.target.value)}
                                            placeholder='Ingrese el nombre de la categoría'
                                            maxLength={50}
                                            autoFocus
                                        />
                                        <div className={getCharacterCounterClass(categoria.length, 50)}>
                                            {categoria.length}/50 caracteres
                                        </div>
                                        {categoria.length > 0 && categoria.length < 2 && (
                                            <div className="form-hint error">
                                                Mínimo 2 caracteres requeridos
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Sección de Subcategorías */}
                            <div className="product-section-card animate-stagger-1">
                                <div className="product-section-header">
                                    <div className="product-section-title">
                                        <FontAwesomeIcon icon={faSitemap} />
                                        Subcategorías
                                    </div>
                                    <div className="product-section-badge">
                                        {subcategorias.length} agregadas
                                    </div>
                                </div>

                                <div className="product-section-content">
                                    {/* Input para agregar subcategorías */}
                                    <div className='product-custom-size-form mb-20'>
                                        <input
                                            type='text'
                                            className='product-form-input'
                                            value={nuevaSubcategoria}
                                            onChange={(e) => setNuevaSubcategoria(e.target.value)}
                                            onKeyPress={handleKeyPress}
                                            placeholder='Agregar subcategoría (presiona Enter)'
                                            maxLength={50}
                                        />
                                        <button
                                            type='button'
                                            onClick={agregarSubcategoria}
                                            className='btn-product-primary'
                                            disabled={!nuevaSubcategoria.trim()}
                                            style={{ gap: '6px', display: 'flex', alignItems: 'center' }}
                                        >
                                            Agregar
                                        </button>
                                    </div>

                                    {nuevaSubcategoria.length > 0 && (
                                        <div className={getCharacterCounterClass(nuevaSubcategoria.length, 50)}>
                                            {nuevaSubcategoria.length}/50 caracteres
                                        </div>
                                    )}

                                    {/* Lista de subcategorías agregadas */}
                                    {subcategorias.length > 0 ? (
                                        <div className="product-sizes-list mt-20">
                                            <div className="subcategories-grid">
                                                {subcategorias.map((sub, index) => (
                                                    <div
                                                        key={index}
                                                        className="subcategory-item"
                                                        style={{ animationDelay: `${index * 0.1}s` }}
                                                    >
                                                        <div className="subcategory-content">
                                                            <FontAwesomeIcon icon={faSitemap} size="sm" />
                                                            {sub}
                                                        </div>
                                                        <button
                                                            type='button'
                                                            onClick={() => eliminarSubcategoria(index)}
                                                            className='btn-product-delete'
                                                            style={{ 
                                                                padding: '6px',
                                                                minWidth: '32px',
                                                                minHeight: '32px',
                                                                borderRadius: '6px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} size="xs" />
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="product-empty-state mt-20">
                                            <FontAwesomeIcon icon={faSitemap} size="3x" />
                                            <div className="empty-title">
                                                No hay subcategorías agregadas
                                            </div>
                                            <div className="empty-description">
                                                Las subcategorías son opcionales pero ayudan a organizar mejor
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Footer usando clases globales */}
                        <div className='product-submit-section'>
                            <button 
                                type='button' 
                                onClick={toggleModal}
                                className='btn-product-secondary'
                            >
                                Cancelar
                            </button>
                            {mensaje ? (
                                <button 
                                    type='button' 
                                    className='btn-product-primary btn-loading-custom'
                                    disabled
                                >
                                    Procesando...
                                </button>
                            ) : (
                                <button 
                                    type='button' 
                                    onClick={crear} 
                                    className='btn-product-primary flex-center'
                                    disabled={!categoria.trim()}
                                    style={{ gap: '8px' }}
                                >
                                    <FontAwesomeIcon icon={faCheck} size="sm" />
                                    Crear Categoría {subcategorias.length > 0 && `(+${subcategorias.length})`}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}